import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
export function Analytics() {
  const [animatedValues, setAnimatedValues] = useState({
    aum: 0,
    irr: 0,
    volume: 0,
    accuracy: 0
  });
  // Animate numbers on mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedValues({
        aum: 98.5,
        irr: 14.7,
        volume: 847.2,
        accuracy: 99.2
      });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  // Chart data
  const monthlyData = [{
    month: 'Jan',
    value: 76.2
  }, {
    month: 'Feb',
    value: 78.8
  }, {
    month: 'Mar',
    value: 82.1
  }, {
    month: 'Apr',
    value: 86.5
  }, {
    month: 'May',
    value: 91.3
  }, {
    month: 'Jun',
    value: 94.7
  }, {
    month: 'Jul',
    value: 98.5
  }];
  const ratingData = [{
    rating: 'AA+',
    value: 15,
    amount: '$14.8M'
  }, {
    rating: 'AA',
    value: 21,
    amount: '$20.7M'
  }, {
    rating: 'AA-',
    value: 18,
    amount: '$17.7M'
  }, {
    rating: 'A+',
    value: 26,
    amount: '$25.6M'
  }, {
    rating: 'A',
    value: 20,
    amount: '$19.7M'
  }];
  const velocityData = [{
    metric: 'Invoices/Day',
    value: '1,247'
  }, {
    metric: 'Avg Processing',
    value: '18 sec'
  }, {
    metric: 'Throughput',
    value: '855/sec'
  }, {
    metric: 'Active Suppliers',
    value: '487'
  }];
  return <div className="min-h-screen bg-gray-50 p-6" data-id="element-413">
      <div className="max-w-[1680px] mx-auto" data-id="element-414">
        {/* Header */}
        <div className="mb-6" data-id="element-415">
          <h1 className="text-3xl font-semibold text-gray-900" data-id="element-416">Analytics</h1>
          <p className="text-gray-600 text-sm mt-1" data-id="element-417">
            Portfolio performance and metrics
          </p>
        </div>

        {/* 4 Big Panels Grid */}
        <div className="grid grid-cols-2 gap-6" data-id="element-418">
          {/* Panel 1: Assets Under Management */}
          <Card className="border-gray-200 shadow-sm" data-id="element-419">
            <div className="p-5 pb-4 border-b border-gray-100" data-id="element-420">
              <div className="flex items-center justify-between" data-id="element-421">
                <div className="flex items-center gap-2" data-id="element-422">
                  <span className="text-gray-500" data-id="element-423">$</span>
                  <span className="text-sm text-gray-600 font-medium" data-id="element-424">
                    Assets Under Management
                  </span>
                </div>
                <span className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-425">
                  LIVE
                </span>
              </div>
            </div>
            <CardContent data-id="element-426">
              <div className="mb-8" data-id="element-427">
                <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-428">
                  ${animatedValues.aum.toFixed(1)}M
                </div>
                <div className="flex items-center gap-2" data-id="element-429">
                  <span className="text-sm text-green-600 font-semibold" data-id="element-430">
                    +18.2%
                  </span>
                  <span className="text-sm text-gray-500" data-id="element-431">
                    Month over month
                  </span>
                </div>
              </div>
              {/* Mini chart */}
              <div className="h-32 flex items-end justify-between gap-2" data-id="element-432">
                {monthlyData.map((month, i) => <div key={month.month} className="flex-1 flex flex-col items-center" data-id="element-433">
                    <div className="w-full bg-gray-300 rounded-t transition-all duration-1000" style={{
                  height: `${month.value / 100 * 120}px`,
                  backgroundColor: i === monthlyData.length - 1 ? '#1f2937' : '#d1d5db'
                }} data-id="element-434" />
                    <span className="text-[10px] text-gray-500 mt-2" data-id="element-435">
                      {month.month}
                    </span>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Panel 2: Returns */}
          <Card className="border-gray-200 shadow-sm" data-id="element-436">
            <div className="p-5 pb-4 border-b border-gray-100" data-id="element-437">
              <div className="flex items-center justify-between" data-id="element-438">
                <div className="flex items-center gap-2" data-id="element-439">
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-440">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" data-id="element-441" />
                  </svg>
                  <span className="text-sm text-gray-600 font-medium" data-id="element-442">
                    Projected IRR
                  </span>
                </div>
                <span className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-443">
                  TARGET 11%
                </span>
              </div>
            </div>
            <CardContent data-id="element-444">
              <div className="mb-8" data-id="element-445">
                <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-446">
                  {animatedValues.irr.toFixed(1)}%
                </div>
                <div className="flex items-center gap-3" data-id="element-447">
                  <div data-id="element-448">
                    <span className="text-sm text-gray-600" data-id="element-449">Gross Yield:</span>
                    <span className="text-sm font-semibold text-gray-900 ml-1" data-id="element-450">
                      12.4%
                    </span>
                  </div>
                  <div className="text-gray-300" data-id="element-451">|</div>
                  <div data-id="element-452">
                    <span className="text-sm text-gray-600" data-id="element-453">Net Spread:</span>
                    <span className="text-sm font-semibold text-gray-900 ml-1" data-id="element-454">
                      385 bps
                    </span>
                  </div>
                </div>
              </div>
              {/* Yield curve visualization */}
              <div className="h-32 flex items-center" data-id="element-455">
                <svg viewBox="0 0 300 100" className="w-full h-full" data-id="element-456">
                  <path d="M 10,80 Q 75,20 150,25 T 290,15" stroke="#1f2937" strokeWidth="3" fill="none" strokeLinecap="round" data-id="element-457" />
                  <circle cx="150" cy="25" r="4" fill="#1f2937" data-id="element-458" />
                  <text x="150" y="18" textAnchor="middle" className="text-[10px] font-semibold fill-gray-700" data-id="element-459">
                    Current
                  </text>
                  <path d="M 10,85 L 290,60" stroke="#9ca3af" strokeWidth="1" fill="none" strokeDasharray="4 2" data-id="element-460" />
                  <text x="290" y="55" textAnchor="end" className="text-[10px] fill-gray-500" data-id="element-461">
                    Benchmark
                  </text>
                </svg>
              </div>
            </CardContent>
          </Card>

          {/* Panel 3: Collection Performance */}
          <Card className="border-gray-200 shadow-sm" data-id="element-462">
            <div className="p-5 pb-4 border-b border-gray-100" data-id="element-463">
              <div className="flex items-center justify-between" data-id="element-464">
                <div className="flex items-center gap-2" data-id="element-465">
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-466">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-467" />
                  </svg>
                  <span className="text-sm text-gray-600 font-medium" data-id="element-468">
                    Collection Performance
                  </span>
                </div>
                <span className="text-xs font-semibold text-green-600 uppercase" data-id="element-469">
                  COMPLIANT
                </span>
              </div>
            </div>
            <CardContent data-id="element-470">
              <div className="grid grid-cols-2 gap-6 mb-6" data-id="element-471">
                <div data-id="element-472">
                  <div className="text-4xl font-bold text-gray-900" data-id="element-473">
                    {animatedValues.accuracy.toFixed(1)}%
                  </div>
                  <div className="text-sm text-gray-600 mt-1" data-id="element-474">
                    Collection Rate
                  </div>
                </div>
                <div data-id="element-475">
                  <div className="text-4xl font-bold text-gray-900" data-id="element-476">0.8%</div>
                  <div className="text-sm text-gray-600 mt-1" data-id="element-477">Default Rate</div>
                </div>
              </div>
              {/* Exposure by Rating */}
              <div className="space-y-2" data-id="element-478">
                <div className="text-xs font-semibold text-gray-700 uppercase mb-3" data-id="element-479">
                  Exposure by Rating
                </div>
                {ratingData.map(item => <div key={item.rating} className="flex items-center gap-3" data-id="element-480">
                    <span className="text-xs font-bold text-gray-700 w-10" data-id="element-481">
                      {item.rating}
                    </span>
                    <div className="flex-1 bg-gray-200 rounded-full h-6 relative overflow-hidden" data-id="element-482">
                      <div className="absolute left-0 top-0 h-full bg-gray-700 rounded-full transition-all duration-1000" style={{
                    width: `${item.value}%`
                  }} data-id="element-483" />
                      <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-semibold text-gray-600" data-id="element-484">
                        {item.amount}
                      </span>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Panel 4: Processing Volume */}
          <Card className="border-gray-200 shadow-sm" data-id="element-485">
            <div className="p-5 pb-4 border-b border-gray-100" data-id="element-486">
              <div className="flex items-center justify-between" data-id="element-487">
                <div className="flex items-center gap-2" data-id="element-488">
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-489">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-490" />
                  </svg>
                  <span className="text-sm text-gray-600 font-medium" data-id="element-491">
                    Processing Velocity
                  </span>
                </div>
                <span className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-492">
                  REALTIME
                </span>
              </div>
            </div>
            <CardContent data-id="element-493">
              <div className="mb-6" data-id="element-494">
                <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-495">
                  ${animatedValues.volume.toFixed(1)}M
                </div>
                <div className="text-sm text-gray-600" data-id="element-496">
                  Annualized Processing Volume
                </div>
              </div>
              {/* Velocity Metrics */}
              <div className="grid grid-cols-2 gap-4" data-id="element-497">
                {velocityData.map(item => <div key={item.metric} className="bg-gray-50 p-3 rounded" data-id="element-498">
                    <div className="text-xl font-bold text-gray-900" data-id="element-499">
                      {item.value}
                    </div>
                    <div className="text-xs text-gray-600 mt-1" data-id="element-500">
                      {item.metric}
                    </div>
                  </div>)}
              </div>
              {/* Growth indicator */}
              <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-501">
                <div className="flex items-center justify-between" data-id="element-502">
                  <span className="text-sm text-gray-600" data-id="element-503">Monthly Growth</span>
                  <div className="flex items-center gap-2" data-id="element-504">
                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-505">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" data-id="element-506" />
                    </svg>
                    <span className="text-lg font-bold text-green-600" data-id="element-507">
                      +28%
                    </span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Bottom Summary Bar */}
        <div className="mt-6 bg-gray-900 text-white p-4 rounded-lg" data-id="element-508">
          <div className="grid grid-cols-5 gap-6" data-id="element-509">
            <div className="text-center" data-id="element-510">
              <div className="text-2xl font-bold" data-id="element-511">943K</div>
              <div className="text-xs text-gray-400 uppercase" data-id="element-512">
                Invoices Processed
              </div>
            </div>
            <div className="text-center" data-id="element-513">
              <div className="text-2xl font-bold" data-id="element-514">1,247</div>
              <div className="text-xs text-gray-400 uppercase" data-id="element-515">
                Daily Throughput
              </div>
            </div>
            <div className="text-center" data-id="element-516">
              <div className="text-2xl font-bold" data-id="element-517">18 sec</div>
              <div className="text-xs text-gray-400 uppercase" data-id="element-518">
                Avg Verification
              </div>
            </div>
            <div className="text-center" data-id="element-519">
              <div className="text-2xl font-bold" data-id="element-520">8.3%</div>
              <div className="text-xs text-gray-400 uppercase" data-id="element-521">
                Human Review
              </div>
            </div>
            <div className="text-center" data-id="element-522">
              <div className="text-2xl font-bold" data-id="element-523">42.3d</div>
              <div className="text-xs text-gray-400 uppercase" data-id="element-524">Avg Tenor</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}